module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms12x-detail-send",
      "id": "hrms12x-detail-send"
    }
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRMS12X']['130']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS12X']['10']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.subject),
      expression: "data.subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "subject",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subject')),
      expression: "errors.has('subject')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('subject')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS12X']['20']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" :")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.msg),
      expression: "data.msg"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "msg",
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.data.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "msg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('msg')),
      expression: "errors.has('msg')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('msg')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS12X']['100']) + " :")]), _vm._v(" "), _c('hrms-dropzone', {
    ref: "hrmsDropzone",
    attrs: {
      "triggerSuccess": _vm.triggerSuccess,
      "flgRename": false
    },
    model: {
      value: (_vm.fileName),
      callback: function($$v) {
        _vm.fileName = $$v
      },
      expression: "fileName"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS12X']['110']) + " :")]), _vm._v(" "), _c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenNotExist:codcomp'),
      expression: "'requiredWhenNotExist:codcomp'"
    }],
    attrs: {
      "disabled": false,
      "nowLang": _vm.nowLang,
      "lovType": "codempid",
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codempid",
      "name": "codempid"
    },
    model: {
      value: (_vm.data.codempid_sender),
      callback: function($$v) {
        _vm.$set(_vm.data, "codempid_sender", $$v)
      },
      expression: "data.codempid_sender"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codempid')),
      expression: "errors.has('codempid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codempid')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS12X']['120']) + " :")]), _vm._v(" "), _c('hrms-lov-codcomp', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenNotExist:codempid'),
      expression: "'requiredWhenNotExist:codempid'"
    }],
    attrs: {
      "nowLang": _vm.nowLang,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codcomp",
      "name": "codcomp"
    },
    model: {
      value: (_vm.data.codcomp_sender),
      callback: function($$v) {
        _vm.$set(_vm.data, "codcomp_sender", $$v)
      },
      expression: "data.codcomp_sender"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codcomp')),
      expression: "errors.has('codcomp')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codcomp')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer padding-b-0"
  }, [_c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSendmail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['sendmail']))]), _vm._v(" "), _c('button', {
    ref: "popupSendMailModalButton",
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.triggerCancelEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['cancel']))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c0d2338!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms12x/detailSend.vue
// module id = 3647
// module chunks = 1